import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { LockIcon, BookOpenIcon } from 'lucide-react';
const GOLD = '#d8b878';
const ACCESS_MOCKUP = 'https://cdn.magicpatterns.com/uploads/pVxRwPF38zmr2Y2SwRkJtV/acceso-interactivo-tablet-celular.webp';
export function InteractiveAccess() {
  const scrollToPrecio = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('precio');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative overflow-hidden bg-matrix-black py-20 md:py-28 px-5 md:px-8" data-id="element-214">
      {/* Depth + texture */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.04]" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, rgba(0,255,65,0.5) 0px, rgba(0,255,65,0.5) 1px, transparent 1px, transparent 22px)',
      maskImage: 'radial-gradient(ellipse at center, black 22%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 22%, transparent 80%)'
    }} data-id="element-215"></div>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_center,_rgba(216,184,120,0.06)_0%,_transparent_55%)]" data-id="element-216"></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-217"></div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-218">
        {/* Left — text */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="order-2 md:order-1 flex-1" data-id="element-219">
          <span className="inline-flex items-center gap-2 font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-5" style={{
          color: 'rgba(216,184,120,0.8)'
        }} data-id="element-220">
            <BookOpenIcon size={13} strokeWidth={1.6} data-id="element-221" />
            Experiencia digital
          </span>
          <h2 className="font-cinzel text-2xl sm:text-3xl md:text-4xl text-matrix-cream leading-[1.2] mb-6 md:mb-7 drop-shadow-[0_0_16px_rgba(245,230,200,0.15)]" data-id="element-222">
            Acceso interactivo{' '}
            <span className="italic" style={{
            color: GOLD
          }} data-id="element-223">
              protegido incluido
            </span>
          </h2>

          <div className="space-y-5 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9] mb-7" data-id="element-224">
            <p data-id="element-225">
              Además de los PDFs descargables, recibirás acceso a las versiones
              flipbook del ebook y del bono.
            </p>
            <p data-id="element-226">
              Una experiencia visual más inmersiva para leer desde tu navegador,
              pasar páginas de forma interactiva y volver a tus materiales
              cuando quieras.
            </p>
          </div>

          {/* Protection note */}
          <div className="mb-9 flex items-start gap-3 rounded-lg border border-matrix-green/20 bg-matrix-dark/50 backdrop-blur-sm px-4 py-3.5" data-id="element-227">
            <LockIcon size={16} strokeWidth={1.6} className="mt-0.5 shrink-0" style={{
            color: GOLD
          }} data-id="element-228" />
            <p className="text-[13px] md:text-sm text-matrix-white/70 font-light leading-relaxed" data-id="element-229">
              El acceso interactivo y la contraseña se entregan únicamente
              después de la compra, dentro del archivo de acceso incluido en la
              descarga.
            </p>
          </div>

          <motion.a href="#precio" onClick={scrollToPrecio} whileHover={{
          scale: 1.03,
          boxShadow: '0 0 34px rgba(216,184,120,0.5)'
        }} whileTap={{
          scale: 0.97
        }} style={{
          backgroundImage: 'linear-gradient(135deg, #e8cf9a 0%, #d8b878 50%, #c4a05f 100%)',
          color: '#0a0f0a'
        }} className="inline-block w-full sm:w-auto text-center whitespace-nowrap font-inter font-bold text-sm md:text-base px-8 md:px-12 py-3.5 md:py-4 rounded-md uppercase tracking-[0.08em] transition-all duration-300 shadow-[0_0_28px_rgba(216,184,120,0.4)] border border-[rgba(255,245,220,0.4)] cursor-pointer outline-none" data-id="element-230">
            QUIERO MI EBOOK + BONO
          </motion.a>
        </motion.div>

        {/* Right — tablet + phone mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1
      }} className="order-1 md:order-2 flex-shrink-0 flex justify-center" data-id="element-231">
          <div className="relative" data-id="element-232">
            <div className="absolute -inset-6 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.16)_0%,_rgba(0,255,65,0.08)_45%,_transparent_72%)] blur-2xl" data-id="element-233"></div>
            <motion.img src={ACCESS_MOCKUP} alt="Acceso interactivo tipo flipbook en tablet y celular" loading="lazy" className="relative z-10 w-64 sm:w-72 md:w-80 lg:w-[26rem] rounded-xl border border-[rgba(216,184,120,0.3)] shadow-[0_30px_70px_-20px_rgba(0,0,0,0.95),0_0_50px_rgba(216,184,120,0.22)]" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-234" />
          </div>
        </motion.div>
      </div>
    </section>;
}